<template>
  <div class="not-found">
   <h1 class="status-code">404</h1>
   <h1>NOT FOUND</h1>
  </div>
</template>
